import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ProgramsSection } from '../components/ProgramsSection';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
export function ProgramsPage() {
  useEffect(() => {
    document.title = "Programs | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-873">
      <Navigation data-id="element-874" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-875">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-876">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-877">
            Our <span className="text-[#00D4FF]" data-id="element-878">Programs</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-879">
            From toddlers to adults, we have a martial arts curriculum designed
            to help you reach your full potential. Discover the perfect class
            for your age and skill level.
          </p>
        </motion.div>
      </div>

      {/* Main Content */}
      <ProgramsSection data-id="element-880" />

      {/* Additional Program Details */}
      <section className="py-20 bg-[#111]" data-id="element-881">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-882">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-883">
            <div data-id="element-884">
              <h2 className="text-3xl font-bold text-white mb-6" data-id="element-885">
                Why Choose Our Curriculum?
              </h2>
              <div className="space-y-6 text-gray-300" data-id="element-886">
                <p data-id="element-887">
                  Our curriculum is built on decades of experience, blending
                  traditional martial arts values with modern teaching
                  methodologies. We don't just teach you how to kick and punch;
                  we teach you how to succeed in life.
                </p>
                <p data-id="element-888">
                  Each program is structured with clear goals and progression
                  paths, ensuring that every student experiences a sense of
                  achievement as they advance through the ranks.
                </p>
                <ul className="space-y-3 mt-6" data-id="element-889">
                  {['Certified Instructors', 'Age-Appropriate Classes', 'Safe Training Environment', 'Personalized Attention'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-890">
                      <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-891" />
                      <span className="text-white font-medium" data-id="element-892">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden" data-id="element-893">
              <img src="https://cdn.magicpatterns.com/uploads/r1PvQh63JZazBt1NNyhiwx/programs.jpg" alt="Instructor teaching students" className="w-full h-full object-cover" data-id="element-894" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" data-id="element-895" />
            </div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-896" />
      <Footer data-id="element-897" />
    </div>;
}